import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class SetAuthorizedTokenUsecase {
  constructor(private readonly appAccountSettingRepo: AppAccountSettingRepository) {}

  async execute(token: string): Promise<SATResult<void, SATError>> {
    return this.appAccountSettingRepo.setAuthorizedToken(token);
  }
}
